import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedComponentsModule } from "../shared-components/shared-components.module";
import { ContactDesktopComponent } from "./contact-desktop.component";
import { ContactFormModule } from "./contact-form/contact-form.module";
import { ContactSectionComponent } from "./contact-section.component";
import { ContactTabletComponent } from "./contact-tablet.component";

@NgModule({
  declarations: [
    ContactSectionComponent,
    ContactDesktopComponent,
    ContactTabletComponent,
  ],
  imports: [CommonModule, ContactFormModule, SharedComponentsModule],
  exports: [ContactSectionComponent],
})
export class ContactSectionModule {}
